export const messages = {
  en: {
    resourceStoreSpecificationManage: {
      queryConditions: 'Query Conditions',
      more: 'More',
      hide: 'Hide',
      selectItemType: 'Select Item Type',
      selectSubCategory: 'Select Sub-category',
      specNamePlaceholder: 'Enter Specification Name',
      specIdPlaceholder: 'Enter Specification ID',
      query: 'Query',
      reset: 'Reset',
      itemSpecifications: 'Item Specifications',
      page: {
        title: 'Item Specifications',
        subtitle: 'Manage second-level specifications by item type',
        empty: 'No specifications found'
      },
      add: 'Add',
      specId: 'Specification ID',
      typeName: 'Type Name',
      specName: 'Specification Name',
      description: 'Description',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      addSpec: 'Add Specification',
      itemType: 'Item Type',
      descriptionPlaceholder: 'Description (optional)',
      save: 'Save',
      cancel: 'Cancel',
      editItemSpec: 'Edit Item Specification',
      confirmDeleteTitle: 'Confirm Operation',
      confirmDeleteMsg: 'Confirm to delete this specification?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    resourceStoreSpecificationManage: {
      queryConditions: '查询条件',
      more: '更多',
      hide: '隐藏',
      selectItemType: '请选择物品类型',
      selectSubCategory: '请选择二级分类',
      specNamePlaceholder: '请输入规格名称',
      specIdPlaceholder: '请输入规格编号',
      query: '查询',
      reset: '重置',
      itemSpecifications: '物品规格',
      page: {
        title: '物品规格管理',
        subtitle: '按物品类型管理二级规格档案',
        empty: '暂无规格数据'
      },
      add: '添加',
      specId: '规格编号',
      typeName: '类型名称',
      specName: '规格名称',
      description: '描述',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      addSpec: '添加规格',
      itemType: '商品类型',
      descriptionPlaceholder: '选填，请填写描述',
      save: '保存',
      cancel: '取消',
      editItemSpec: '修改物品规格',
      confirmDeleteTitle: '请确认您的操作',
      confirmDeleteMsg: '确定删除物品规格',
      cancelDelete: '点错了',
      confirmDelete: '确认删除'
    }
  }
}